/**
 * Theme configurations
 * Each theme includes colors, gradients, and shadows
 */

export const THEMES = {
  default: {
    id: 'default',
    name: 'Purple Gradient',
    colors: {
      primary: '#667eea',
      primaryDark: '#5568d3',
      secondary: '#764ba2',
      accent: '#667eea',
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      background: '#f8f9ff',
      surface: '#ffffff',
      text: '#333333',
      textSecondary: '#666666',
      border: '#e0e0e0',
    },
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    shadow: '0 4px 20px rgba(102, 126, 234, 0.3)',
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean Blue',
    colors: {
      primary: '#0077be',
      primaryDark: '#005a8d',
      secondary: '#00a8e8',
      accent: '#0077be',
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      background: '#f0f8ff',
      surface: '#ffffff',
      text: '#1a1a1a',
      textSecondary: '#555555',
      border: '#d0e8f0',
    },
    gradient: 'linear-gradient(135deg, #0077be 0%, #00a8e8 100%)',
    shadow: '0 4px 20px rgba(0, 119, 190, 0.3)',
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset Orange',
    colors: {
      primary: '#ff6b35',
      primaryDark: '#e85a2a',
      secondary: '#ff9f1c',
      accent: '#ff6b35',
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      background: '#fff8f0',
      surface: '#ffffff',
      text: '#2d2d2d',
      textSecondary: '#5a5a5a',
      border: '#ffe0cc',
    },
    gradient: 'linear-gradient(135deg, #ff6b35 0%, #ff9f1c 100%)',
    shadow: '0 4px 20px rgba(255, 107, 53, 0.3)',
  },
  forest: {
    id: 'forest',
    name: 'Forest Green',
    colors: {
      primary: '#2d6a4f',
      primaryDark: '#1f4a36',
      secondary: '#40916c',
      accent: '#2d6a4f',
      success: '#52b788',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      background: '#f1f8f4',
      surface: '#ffffff',
      text: '#1a1a1a',
      textSecondary: '#4a4a4a',
      border: '#d8f3dc',
    },
    gradient: 'linear-gradient(135deg, #2d6a4f 0%, #40916c 100%)',
    shadow: '0 4px 20px rgba(45, 106, 79, 0.3)',
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight Purple',
    colors: {
      primary: '#5e35b1',
      primaryDark: '#4527a0',
      secondary: '#7e57c2',
      accent: '#5e35b1',
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      background: '#f3f0f8',
      surface: '#ffffff',
      text: '#2d2d2d',
      textSecondary: '#5a5a5a',
      border: '#e1d9f0',
    },
    gradient: 'linear-gradient(135deg, #5e35b1 0%, #7e57c2 100%)',
    shadow: '0 4px 20px rgba(94, 53, 177, 0.3)',
  },
  rose: {
    id: 'rose',
    name: 'Rose Pink',
    colors: {
      primary: '#d81b60',
      primaryDark: '#ad1457',
      secondary: '#ec407a',
      accent: '#d81b60',
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      background: '#fef0f5',
      surface: '#ffffff',
      text: '#2d2d2d',
      textSecondary: '#5a5a5a',
      border: '#fcd4e5',
    },
    gradient: 'linear-gradient(135deg, #d81b60 0%, #ec407a 100%)',
    shadow: '0 4px 20px rgba(216, 27, 96, 0.3)',
  },
  dark: {
    id: 'dark',
    name: 'Dark Mode',
    colors: {
      primary: '#8b9aff',
      primaryDark: '#7889ff',
      secondary: '#9f8bff',
      accent: '#8b9aff',
      success: '#66bb6a',
      error: '#ef5350',
      warning: '#ffb74d',
      info: '#42a5f5',
      background: '#1a1a1a',
      surface: '#2d2d2d',
      text: '#e8e8e8',
      textSecondary: '#b8b8b8',
      border: '#404040',
    },
    gradient: 'linear-gradient(135deg, #8b9aff 0%, #9f8bff 100%)',
    shadow: '0 4px 20px rgba(139, 154, 255, 0.3)',
  },
};

export const DEFAULT_THEME = 'default';
